import {
  CORE_SELF_SERVE_NAME,
  CoreSelfServeComponent,
} from "@b2bportal/core-types";

import { useStyles } from "../context";

// Hook to apply styles to Flight components
export const useSelfServeStyles = (
  componentName: keyof typeof CoreSelfServeComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_SELF_SERVE_NAME, componentName, defaultStyles);
};
